module.exports = __webpack_public_path__ + "img/teacher.d761691e.png";